export const IMG_SRC_URL = process.env.REACT_APP_IMG_SRC_URL;
export const ATTACHMENTS_SRC_URL = process.env.REACT_APP_ATTACHMENTS_SRC_URL;
export const DOCUMENTS_SRC_URL = process.env.REACT_APP_DOCUMENTS_SRC_URL;
export const BANNERS_SRC_URL = process.env.REACT_APP_BANNERS_SRC_URL;
export const SINTEGRA_HOMO: boolean =
    process.env.REACT_APP_SINTEGRA_HOMO === '1';
export const NEXEN_BUCKET_SRC_URL = process.env.REACT_APP_NEXEN_BUCKET_SRC_URL;
